import {
  addDays,
  addMonths,
  isAfter,
  max,
  parseISO,
  startOfMonth
} from 'date-fns';

import type { OpeningScheduleResponse } from 'generated/index';

import type { CopyOpeningScheduleFormValues } from '../OpeningHours.types';

/**
 * What the copy dialog starts with: the original's name with "(2)", from the first of next month -
 * or later, since a still valid original ends where the copy starts and must keep a day of its own -
 * to the original's end if that lies beyond the start.
 */
export const getCopyDefaults = (
  schedule: OpeningScheduleResponse,
  today: Date
): CopyOpeningScheduleFormValues => {
  const validFrom = max([
    startOfMonth(addMonths(today, 1)),
    addDays(parseISO(schedule.validFrom), 1)
  ]);
  const validTo =
    schedule.validTo && isAfter(parseISO(schedule.validTo), validFrom)
      ? parseISO(schedule.validTo)
      : null;
  return { name: `${schedule.name} (2)`, validFrom, validTo };
};

/** Whether the original is still valid on the copy's first day, and so ends there. */
export const closesOriginal = (
  schedule: OpeningScheduleResponse,
  copyFrom: Date | null
): boolean =>
  !!copyFrom &&
  (!schedule.validTo || isAfter(parseISO(schedule.validTo), copyFrom));
